
<div class="sub-editor">
  <div class="close-button">
    <a> <mat-icon mat-dialog-close>close</mat-icon> </a>
  </div>
  <form [formGroup]="subEditorForm">
    <div class="subEditor mat-dialog" mat-dialog-content>
      <div class="main-heading"> <label> {{edit + ' '+ title | translate}}</label> </div>
      <ckeditor #myEditor [editor]="Editor" formControlName="abc" (click)="onClick(true)" (ready)="onReady($event)" [(ngModel)]='updatedValue'></ckeditor>
      <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
    </div>
  </form>
  <div mat-dialog-actions>
    <button mat-flat-button color="" class="btn-primary btn-size" (click)="updateAndClose()">
      {{'questions.typeOfQuestions.standard.editOption.btnSave' | translate}}
    </button>
  </div>

</div>
